/**
 * ADD RSS FEED ENTRY POINT
 *
 * The preview company page shows the available articles for a non active entity
 *
 * @version 0.1
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { hashHistory } from 'react-router';

import utils from './../../../utils/utilities';
import reduxStore from './../../../reduxStore';

import headerActions from './../../../reusable/Header/Header.actions.js';
import actions from './BaseFeedEditingComponent.actions.js';
import FeedInformation from './template/BaseFeedEditingComponent.feedInformation.jsx';
import RiskAnglesLevels from './template/BaseFeedEditingComponent.riskAnglesLevels.jsx';
import ThirdPartiesReduxLayer from './FeedsThirdPartiesReduxLayer';

export default class BaseFeedEditingComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = reduxStore.getState().addRssFeed;

        this.feedId = undefined;

        this.saveFeed = this.saveFeed.bind(this);
        this.setErrorClass = this.setErrorClass.bind(this);
        this.treatSaveErrors = this.treatSaveErrors.bind(this);
        this.isSaveActive = this.isSaveActive.bind(this);
        this.setSaveButtonClass = this.setSaveButtonClass.bind(this);
        this.returnToFeedsPage = this.returnToFeedsPage.bind(this);
    }

    componentWillMount(pageStatus, feedId) {

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().addRssFeed);
            }
        );

        this.feedId = feedId ? feedId : undefined;

        headerActions.updateHeader(pageStatus);
        actions.resetAddRssFeedPage();
        reduxStore.dispatch({type: 'HIDE_SPINNER'});
    }

    componentDidMount() {
        this.rootComponentNode = ReactDOM.findDOMNode(this);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    treatSaveErrors(response) {

        if (utils.isArray(response) && response.length > 0) {
            let errors = response;

            for (let i = 0; i < errors.length; i++) {
                actions.addValidationError(errors[i].validationCode);
            }
        }

        let saveErrors            = this.state.saveErrors,
            feedInfoTitle         = this.rootComponentNode.getElementsByClassName('feed-info-title')[0],
            thirdPartiesTitle     = this.rootComponentNode.getElementsByClassName('third-parties-title')[0],
            riskAnglesLevelsTitle = this.rootComponentNode.getElementsByClassName('risk-angels-levels-title')[0];

        if (utils.arrayDiff([
                'api.error.feed.duplicateTitle',
                'api.error.feed.missingTitle'
            ], saveErrors, true).length !== 2) {

            window.scrollBy(0, feedInfoTitle.getBoundingClientRect().top);

        } else if (utils.inArray('api.error.feed.noRiskEntities', saveErrors) > -1) {
            window.scrollBy(0, thirdPartiesTitle.getBoundingClientRect().top);
        } else if (utils.inArray('api.error.feed.noPestle', saveErrors) > -1) {
            window.scrollBy(0, riskAnglesLevelsTitle.getBoundingClientRect().top);
        }

    }

    saveFeed() {
        let feedNameInputValue = this.rootComponentNode.getElementsByClassName("feed-name-input")[0].value,
            riskAngleLevels    = this.state.riskAngles;
        
        let thirdParties = [];

        for (let i = 0; i < this.state.thirdParties.selectedThirdParties.length; i++) {
            thirdParties.push(this.state.thirdParties.selectedThirdParties[i].id);
        }

        actions.saveFeed(
            {
                id:       this.feedId,
                title:    feedNameInputValue,
                metaData: {
                    selectAllThirdParties: this.state.thirdParties.thirdPartySelectionBox ===
                                           'all-third-parties-section',
                    categories:            this.state.thirdParties.selectedCategories,
                    thirdParties:          thirdParties,
                    riskLevels:            riskAngleLevels
                }
            },
            this.feedId ? 'put' : 'post',
            this.treatSaveErrors
        ).catch((error) => {
            utils.logError(error, 'RSS feed save error: ');
        });

    }

    returnToFeedsPage() {
        if (this.logFeedCreateCancel) {
            this.logFeedCreateCancel();
        }

        hashHistory.push('/feeds');
    }

    setErrorClass(errorIds) {
        for (let i = 0; i < errorIds.length; i++) {
            if (utils.inArray(errorIds[i], this.state.saveErrors) > -1) {
                return ' shown';
            }
        }

        return '';
    }

    isSaveActive(feedId) {

        // Do not disable the save button if you are on the Edit Feed page.
        return this.state.isFeedNameValid || feedId ? true : false;

    }

    setSaveButtonClass(feedId = null) {
        return this.isSaveActive(feedId) ? '' : ' disabled';
    }

    render(feedId) {

        return (
            <div className="add-rss-page">

                <FeedInformation setErrorClass={this.setErrorClass} feedId={feedId} />
                <ThirdPartiesReduxLayer />
                <RiskAnglesLevels ref="riskAnglesLevels" setErrorClass={this.setErrorClass} />

                <div className="buttons-container">

                    <button className={'button-primary-lg save' + this.setSaveButtonClass(feedId)}
                            type="button"
                            onClick={this.isSaveActive(feedId) ? this.saveFeed : null}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.save" />
                    </button>

                    <button className="button-secondary-lg cancel" type="button" onClick={this.returnToFeedsPage}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                    </button>

                </div>

            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/BaseFeedEditingComponent.index.jsx